var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cartItemsCount)?_c('span',{staticClass:"cart"},[_c('span',{staticClass:"cart-icon"}),_vm._v(" "+_vm._s(_vm.cartItemsCount)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }